import "../styles/genai.css";
import powerbiHeroImg from "../assets/powerbi-hero.png";

export default function PowerBIHero() {
  return (
    <section
      className="genai-hero full-hero"
      style={{
        backgroundImage: `url(${powerbiHeroImg})`,
      }}
    >
      {/* OVERLAY */}
      <div className="hero-overlay"></div>

      {/* CONTENT */}
      <div className="hero-content">
        <h1 className="hero-title">
          POWER BI DATA ANALYST PROGRAM
        </h1>

        <p className="hero-desc">
          Learn to Transform Data into Interactive Dashboards & Business Insights
        </p>

      </div>
    </section>
  );
}